<template>
    <xx-level-select
        ref="levelSelect"
        :value="innerValue"
        :data="innerData"
        :multiple="multiple"
        :max-selected-count="maxSelectedCount"
        :filter-in-all="!onlyOneTab"
        :tab-config="innerTabConfig"
        :value-key="innerRowValueKey"
        filter-placeholder="请搜索门店"
        :show-select-all="innerShowSelectAll"
        useScrollAllData
        @tab-change="handleTabChange"
        @input="handleInput"
        @change="handleChange"
        @data-update="handleDataUpdate"
        v-bind="$attrs"
        v-on="listeners"
    ></xx-level-select>
</template>
<script>
import { deepClone, omit } from '@lsfe/tools';
import {formatToTree} from './utils';
import { isEqual } from '../../utils/tools';

const dataBuffer = {};

const getType = data => {
    let value = data;
    if (Array.isArray(value)) {
        value = value[0];
    }
    if (value === '' || value === undefined || value === null) {
        return;
    }
    return typeof value;
};

export default {
    name: 'XxPoiselect',
    props: {
        value: {
            required: true
        },
        usePermission: {
            required: true,
            type: Boolean
        },
        bizId: {
            type: [String, Number, Array],
            default: '0'
        },
        responseProcessor: {
            type: Function
        },
        nodeIdWithLevel: {
            type: Boolean,
            default: false
        },
        nodeInfoTmp: {
            type: Array,
            default: () => {
                return [
                    { idName: 'regionOrgId', labelName: 'regionOrgName' },
                    { idName: 'cityOrgId', labelName: 'cityOrgName' },
                    { idName: 'orgId', labelName: 'poiName' }
                ];
            }
        },
        multiple: {
            type: Boolean,
            default: true
        },
        onlyOneTab: {
            type: Boolean,
            default: false
        },
        tabConfig: {
            type: [Array, Boolean],
            default: () => [
                {
                    label: '全部',
                    filter: () => true
                },
                {
                    label: 'C1项目',
                    filter: data => data.poiBizId === 2
                },
                {
                    label: 'C2项目',
                    filter: data => data.poiBizId === 3
                },
                {
                    label: 'C3项目',
                    filter: data => data.poiBizId === 4
                },
                {
                    label: '生鲜',
                    filter: data => data.poiBizId === 1
                }
            ]
        },
        // 请求信息配置
        ajax: Object,
        // 数据源
        list: Array,
        // 处理树形数据
        treeNodesProcesser: Function,
        // 门店类型
        poiTypes: Array,
        autoLoad: {
            type: Boolean,
            default: true
        },
        rowValueKey: {
            type: String,
            default: 'poiId'
        },
        // 兼容老的方法，该方法会在每次发生变化的时候触发
        rawNodesProcesser: {
            type: Function
        },
        valueType: {
            type: String,
            default: 'number'
        },
        selectFirst: {
            type: Boolean,
            default: false
        },
        showNoRightsNodes: {
            type: Boolean,
            default: false
        },
        // disabledIds动态控制disabled的门店
        disabledIds: {
            type: Array
        },
        needRDC: {
            type: Number,
            default: 0
        },
        showPoiId: {
            type: Boolean,
            default: false
        },
        // c3门店的配置
        // show 控制是否展示 poiType 控制门店展示类型
        c3Config: {
            type: Object,
        },
        maxSelectedCount: {
            type: Number,
            default: Infinity,
        },
        showAsCity: {
            type: Boolean,
            default: false
        },
        // 门店状态：1：在线 2：下线
        status: {
            type: Number,
        },
        showSelectAll: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            innerValue: this.formatValueToType(this.value, this.valueType),
            storeType: getType(this.value),
            data: [],
            intinalData: [],
            sourceData: [],
            innerDisabledIds: this.disabledIds,
            innerTypes: this.poiTypes,
            innerBizId: this.bizId,
            innerC3Config: this.c3Config,
            filterTabConfig: this.tabConfig,
            innerStatus: this.status,
            innerNodeIdWithLevel: this.showAsCity ? true : this.nodeIdWithLevel,
            innerNodeInfoTmp: this.formatNodeInfoTmp(this.nodeInfoTmp),
            filterData: []
        };
    },
    watch: {
        value(val) {
            this.storeType = getType(val) || this.storeType;
            this.innerValue = this.formatValueToType(val, this.valueType);
        },
        ajax() {
            this.$nextTick(this.getData);
        },
        list() {
            this.getData(false);
        },
        poiTypes: {
            handler(val) {
                if (!isEqual(val, this.innerTypes)) {
                    this.innerTypes = val;
                }
            },
            deep: true
        },
        bizId: {
            handler(val) {
                if (!isEqual(val, this.innerBizId)) {
                    this.innerBizId = val;
                }
            },
            deep: true
        },
        status: {
            handler(val) {
                if (!isEqual(val, this.innerStatus)) {
                    this.innerStatus = val;
                }
            },
            deep: true
        },
        disabledIds: {
            handler(val) {
                if (!isEqual(val, this.innerDisabledIds)) {
                    this.innerDisabledIds = val;
                }
            },
            deep: true
        },
        c3Config: {
            handler(val) {
                if (!isEqual(val, this.innerC3Config, true)) {
                    this.innerC3Config = val;
                }
            },
            deep: true
        },
        nodeInfoTmp: {
            handler(val) {
                if (!isEqual(val, this.innerNodeInfoTmp)) {
                    this.innerNodeInfoTmp = this.formatNodeInfoTmp(val);
                }
            }
        },
        tabConfig(val) {
            this.filterTabConfig = (val || []).filter(item => !item.filter || this.filterData.some(item2 => item.filter(item2)));
        },
        filterData: {
            handler(val) {
                // 每一次数据过滤，都要重新计算tabConfig是否需要过滤
                this.filterTabConfig = (this.tabConfig || []).filter(item => !item.filter || val.some(item2 => item.filter(item2)));
            }
        }
    },
    computed: {
        innerShowSelectAll() {
            return this.showAsCity ? false : this.showSelectAll;
        },
        innerRowValueKey() {
            return this.showAsCity ? 'cityId' : this.rowValueKey;
        },
        innerData() {
            let data = deepClone(this.sourceData);
            data = this.handleFilterData(data);
            this.filterData = data;
            if (this.rawNodesProcesser && typeof this.rawNodesProcesser === 'function') {
                data = this.rawNodesProcesser(data);
            }
            data = formatToTree(data, this.innerNodeInfoTmp, {idWithLevel: this.innerNodeIdWithLevel});
            if (this.treeNodesProcesser) {
                data = this.treeNodesProcesser(data);
            }
            return data;
        },
        innerTabConfig() {
            if (this.showAsCity) {
                return [];
            }
            const tabConfig = this.filterTabConfig;
            if (!this.onlyOneTab || (tabConfig || []).some(item => item.render)) {
                return tabConfig;
            }
            return (tabConfig || []).map(item => {
                return {
                    ...item,
                    render: (h, activeTab) => {
                        return (
                            <span>
                                <el-radio value={activeTab.label === item.label} label={true}>
                                    {item.label}
                                </el-radio>
                            </span>
                        );
                    }
                };
            });
        },
        listeners() {
            const listeners = omit(this.$listeners, ['input', 'change', 'data-update']);
            return listeners;
        }
    },
    created() {
        this.initConfig();
        this.getData();
    },
    methods: {
        handleInput(val) {
            const value = this.formatValueToType(val, this.storeType);
            this.$emit('input', value);
        },
        handleChange(val, items) {
            const value = this.formatValueToType(val, this.storeType);
            this.$emit('change', value, items);
        },
        handleDataUpdate(val, items, data) {
            const value = this.formatValueToType(val, this.storeType);
            this.$emit('data-update', value, items, data);
        },
        resetOption(fun) {
            this.sourceData = fun(deepClone(this.intinalData));
        },
        handleTabChange() {
            if (this.multiple && this.onlyOneTab) {
                this.$emit('input', []);
                this.$emit('change', [], undefined);
            }
        },
        initConfig() {
            if (this.showAsCity) {
                this.innerNodeInfoTmp = [
                    { idName: 'regionOrgId', labelName: 'regionOrgName' },
                    { idName: 'cityId', labelName: 'cityName' },
                ];
            }
        },
        // isFirst标志是否首次渲染后获取数据
        async getData(isFirst = true) {
            let data = [];
            if (this.list) {
                data = this.list;
            } else if (this.autoLoad) {
                data = await this.fetchData();
                if (this.showNoRightsNodes && this.usePermission) {
                    // 使用权限并且要展示没有权限的数据时
                    let withoutPermissionData = await this.getAllData();
                    withoutPermissionData.forEach(item => {
                        if (data.findIndex(item2 => item[this.innerRowValueKey] === item2[this.innerRowValueKey]) === -1) {
                            // 没有权限的数据，添加disabled然后加入
                            data.push({
                                ...item,
                                disabled: true
                            });
                        }
                    });
                }
            }
            this.intinalData = data;
            this.sourceData = deepClone(data);
            this.filterData = this.handleFilterData(deepClone(data));
            // 选择第一项
            if (this.selectFirst && isFirst) {
                let item = this.filterData[0];
                if (!item) {
                    return;
                }
                let value = item[this.innerRowValueKey];
                if (this.multiple) {
                    // 支持多选选中第一项的时候返回数组
                    value = [value];
                    item = [item];
                }
                this.handleInput(value);
                this.handleChange(value, item);
            }
        },
        async getAllData() {
            let data = [];
            const bufferKey = `false-${this.needRDC}`;
            if (!dataBuffer[bufferKey]) {
                dataBuffer[bufferKey] = this.$hGet('/api/auth/org/getRegionAndPoiModelMap', {bizId: 0});
            }
            await dataBuffer[bufferKey].then(res => {
                const { regionAndPOiList } = res || {};
                data = regionAndPOiList;
            }).catch(() => {});
            data = this.formatValueType(data);
            this.$emit('loaded-without-permission', data);
            return data;
        },
        formatValueToType(val, type) {
            // 把当前数据的类型暂存存储起来
            const valType = getType(val);
            // const valueType = this.valueType || 'number';
            // 设置数据类型为valueType类型
            if (!type || valType === type || val === '' || val === undefined || val === null || (Array.isArray(val) && !val.length)) {
                // 类型相同、空或者空数组
                return val;
            }
            if (Array.isArray(val)) {
                // 数据类型跟valueType不一致，需要修改数据
                val = val.map(item => {
                    if (type === 'number') {
                        return +item;
                    } else {
                        return `${item}`;
                    }
                });
            } else {
                val = type === 'number' ? +val : `${val}`;
            }
            return val;
        },
        async fetchData() {
            let api = this.usePermission ? '/api/auth/org/getRegionAndPoiModelMapWithPermission' : '/api/auth/org/getRegionAndPoiModelMap';
            let params = {
                needRdc: this.usePermission ? this.needRDC : undefined,
                bizId: 0
            };
            let type = 'hGet';
            let data = [];
            let options = {};
            if (this.ajax) {
                api = this.ajax.url;
                ({ params, options, type } = this.ajax);
            }
            // 如果有传入的获取数据源的配置
            const bufferKey = `${this.usePermission}-${this.needRDC}`;

            if (!dataBuffer[bufferKey]) {
                dataBuffer[bufferKey] = this[`$${type}`](api, params, options);
            }
            await dataBuffer[bufferKey].then(res => {
                const { regionAndPOiList } = res || {};
                data = regionAndPOiList;
            }).catch(() => {});
            if (this.responseProcessor && typeof this.responseProcessor === 'function') {
                // responseProcessor 为异步函数时, 需要使用 await 防止formatValueType方法报错
                data = await this.responseProcessor(data);
            }
            data = this.formatValueType(data);
            this.$emit('loaded', deepClone(data));
            return data;
        },
        handleFilterData(data) {
            if (this.innerC3Config) {
                const {show, poiTypes} = this.innerC3Config;
                if (show === false || poiTypes) {
                    data = data.filter(item => {
                        if (item.poiBizId !== 4) {
                            // 非C3直接通过
                            return true;
                        }
                        // C3处理
                        if (show === false) {
                            return false;
                        }
                        if (poiTypes) {
                            return poiTypes.includes(item.poiType);
                        }
                        return true;
                    });
                }
            }
            if (this.innerTypes || this.innerDisabledIds || this.innerBizId || this.innerStatus) {
                data = data.filter(item => {
                    if (this.innerDisabledIds && this.innerDisabledIds.includes(item[this.innerRowValueKey])) {
                        item.disabled = true;
                    }
                    if (this.innerTypes && !this.innerTypes.includes(item.poiType)) {
                        return false;
                    }
                    if (this.innerStatus && this.innerStatus !== item.poiStatus) {
                        return false;
                    }
                    // 0的时候直接抛出，作为选择全部bizId的条件，包括0,'0',null,''，目的是兼容之前的'0'的用法
                    if (+this.innerBizId !== 0) {
                        const bizIds = !this.innerBizId || Array.isArray(this.innerBizId) ? this.innerBizId : [this.innerBizId];
                        if (bizIds && !bizIds.map(id => +id).includes(item.poiBizId)) {
                            return false;
                        }
                    }
                    return true;
                });
            }
            return data;
        },
        formatNodeInfoTmp(data) {
            if (this.showPoiId) {
                return data.map(item => {
                    if (item.idName !== 'orgId') {
                        return item;
                    }
                    return {
                        ...item,
                        labelRender: data => {
                            return `${data.poiId}-${data.poiName}`;
                        }
                    };
                });
            }
            return data;
        },
        formatValueType(data) {
            if (this.valueType && this.valueType === 'string') {
                // 如果类型指定为string，则进行数据转换
                return data.map(item => {
                    return {
                        ...item,
                        [this.innerRowValueKey]: `${item[this.innerRowValueKey]}`
                    };
                });
            }
            return data;
        },
        getSelectedValue() {
            return this.$refs.levelSelect.getSelectedValue();
        }
    }
};
</script>
<style lang="scss" scoped></style>
